import { createRoute, redirect } from '@tanstack/react-router';

import { CardDetail, TaskDetail } from '@web/ui/card_detail';
import { TriagePage } from '@web/ui/triage';

import { orgWorkspaceLayoutRoute } from './overview_routes';

/**
 * `autoOpen: false` — a caixa não reabre o primeiro card sozinha. É o que o
 * voltar do card pede; sem isso ele reabriria um card (ver `TriagePage`).
 */
export type TriageSearch = { autoOpen?: false };

/** `/orgs/$orgSlug/triage` — a caixa de triagem (cards sem squad). */
export const triageIndexRoute = createRoute({
  getParentRoute: () => orgWorkspaceLayoutRoute,
  path: 'triage',
  component: TriagePage,
  validateSearch: (input: Record<string, unknown>): TriageSearch =>
    input.autoOpen === 'false' ? { autoOpen: false } : {},
});

/** Pai sem componente: só agrupa o card sem squad sob a triagem. */
export const triageCardRoute = createRoute({
  getParentRoute: () => triageIndexRoute,
  path: 'card/$cardId',
});

/**
 * Index — redireciona `/triage/card/$cardId` para a aba padrão. Fica no index
 * (não no `beforeLoad` do pai) pelo mesmo motivo de `customerIndexRoute`: o
 * pai rodaria para toda URL de aba e forçaria todas de volta para `conversation`.
 */
export const triageCardIndexRoute = createRoute({
  getParentRoute: () => triageCardRoute,
  path: '/',
  beforeLoad: ({ params }) => {
    redirect({
      throw: true,
      to: '/orgs/$orgSlug/triage/card/$cardId/$tab',
      params: { ...params, tab: 'conversation' },
    });
  },
});

/**
 * O MESMO `CardDetail` do board, sem squad: drawer com abas quando o card não
 * é meu, tela cheia quando assumido. `useCardRoutes` resolve a família pelo
 * `squadId` ausente.
 */
export const triageCardTabRoute = createRoute({
  getParentRoute: () => triageCardRoute,
  path: '$tab',
  component: CardDetail,
});

/** Detalhe da tarefa ao lado do card, como na rota do squad. */
export const triageCardTaskRoute = createRoute({
  getParentRoute: () => triageCardTabRoute,
  path: 'task/$taskId',
  component: TaskDetail,
});
